import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var IconTooltip = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? ["fas", "circle-info"] : _b, _c = _a.color, color = _c === void 0 ? "var(--darkGray)" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, onClick = _a.onClick, children = _a.children;
    return (_jsxs("div", { className: "duration-1000 tooltip-holder cursor-pointer ".concat(className), children: [_jsx(FontAwesomeIcon, { icon: icon, color: color, onClick: onClick }), _jsx("span", { children: children })] }));
};
export default IconTooltip;
